export interface Tag {
  id: string;
  name: string;
  color: string;
}

export interface TagBadgeProps {
  name: string;
  color: string;
  onRemove?: () => void;
  onClick?: () => void;
  className?: string;
}

export interface TagColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  label?: string;
}

export interface TagInputProps {
  availableTags: Tag[];
  selectedTagIds: string[];
  onChange: (tagIds: string[]) => void;
  label?: string;
  placeholder?: string;
  onCreateTag?: (name: string) => void;
  defaultOpen?: boolean;
  onClose?: () => void;
}

export interface TagFormDialogProps {
  open: boolean;
  onClose: () => void;
  mode: "create" | "edit";
  initialData?: { name: string; color: string };
  onSubmit: (data: { name: string; color: string }) => Promise<void>;
}

export interface TagDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  tagName: string;
  usageCount?: number;
  onConfirm: () => Promise<void>;
}

export interface TagCardProps {
  tag: Tag;
  mode: "view" | "edit" | "delete";
  onStartEdit: () => void;
  onCancelEdit: () => void;
  onSave: (data: { name: string; color: string }) => Promise<void>;
  onStartDelete: () => void;
  onCancelDelete: () => void;
  onConfirmDelete: () => Promise<void>;
  animationDelay?: number;
}

export interface TagInlineCreateRowProps {
  onSave: (data: { name: string; color: string }) => Promise<void>;
  onCancel: () => void;
}

export interface TagListProps {
  tags: Tag[];
  onEdit: (tag: Tag) => void;
  onDelete: (tag: Tag) => void;
  onCreate?: () => void;
  /** Managed mode props - when provided, TagList renders inline editing */
  editingTagId?: string | null;
  deletingTagId?: string | null;
  onCancelEdit?: () => void;
  onSaveEdit?: (data: { name: string; color: string }) => Promise<void>;
  onCancelDelete?: () => void;
  onConfirmDelete?: () => Promise<void>;
}

export interface TagManagementSheetProps {
  open: boolean;
  onClose: () => void;
  title: string;
  tags: Tag[];
  onCreateTag: (data: { name: string; color: string }) => Promise<void>;
  onUpdateTag: (
    id: string,
    data: { name: string; color: string },
  ) => Promise<void>;
  onDeleteTag: (id: string) => Promise<void>;
}

export const TAG_COLORS = [
  "#93C5FD",
  "#86EFAC",
  "#FCD34D",
  "#FDA4AF",
  "#C4B5FD",
  "#5EEAD4",
  "#FDBA74",
  "#D1D5DB",
] as const;

export const DEFAULT_TAG_COLOR = "#D1D5DB";
